<template>
  <div
    class="history-recommend"
    v-if="historySearchText && historySearchText.length"
  >
    <div class="title-common">
      <div class="title-common__text">{{ $t('最近搜过') }}：</div>
      <div class="title-common__icon">
        <i class="icon-outlined_delete" @click="openDelHistoryDialog"></i>
      </div>
    </div>
    <div class="hot-text__content">
      <div
        class="hot-text finger-style"
        v-for="(item, idx) in historySearchText"
        :key="idx"
        @click="handleSelect(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HistoryRecommend',
  props: {
    historySearchText: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  methods: {
    openDelHistoryDialog() {
      this.$emit('openDelHistoryDialog');
    },
    handleSelect(item) {
      this.$trackEvent({
        eventId: 'sailing_c_x_search_historyword_ck',
        eventLabel: '历史搜索词点击',
        attrs: {
          history_word: item,
        },
      });
      this.$emit('handleSelect', 1, item);
    },
  },
};
</script>
<style lang="scss" src="./common.scss"></style>
